const meta = {
  explorer: 'Metrics Explorer',
  builder: 'Query Builder',
  'derived-telemetry': 'Derived telemetry',
  'query-builder': {
    display: 'hidden',
  },
  'delta-queries': 'Use delta queries',
  fixing: 'Fix slow queries',
  troubleshooting: 'Troubleshoot',
  'explorer-classic': 'Metrics Explorer (classic)',
};

export default meta;
